// extracted by css-extract-rspack-plugin
export default {"positioner":"positioner-QWCtC7","defaultVariant":"defaultVariant-E3PR0s","compactVariant":"compactVariant-YLWXAc","squareCorners":"squareCorners-bcUHVj","button":"button-y_bsoT"};